/* =====================================================================
 * Typography — font stacks.
 *
 * Component-level typography (markdown, bubble, modal, input, dm,
 * sidebar, and their mobile overrides) lives in `./component.ts`.
 * ===================================================================== */

export const fonts = {
  sans: "'Pretendard Variable', Pretendard, -apple-system, 'Segoe UI', Roboto, sans-serif",
  mono: "'JetBrains Mono', 'SF Mono', Menlo, monospace",
} as const;

export type Fonts = typeof fonts;
